import { render, staticRenderFns } from "./LenderDashboard.vue?vue&type=template&id=1d2fa4d4&scoped=true"
import script from "./LenderDashboard.vue?vue&type=script&lang=js"
export * from "./LenderDashboard.vue?vue&type=script&lang=js"
import style0 from "./LenderDashboard.vue?vue&type=style&index=0&id=1d2fa4d4&prod&scoped=true&lang=css"
import style1 from "./LenderDashboard.vue?vue&type=style&index=1&id=1d2fa4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fa4d4",
  null
  
)

export default component.exports